import "@/styles/footer.scss"

const Footer = () => {
    return (
        <footer>
            <ul>
                <li>
                    <a href="https://www.qlife.co.jp/privacypolicy">
                        個人情報保護方針
                    </a>
                </li>
                <li>
                    <a href="https://www.qlife.co.jp/">会社概要</a>
                </li>
            </ul>
            <p>&copy; QLife, Inc.</p>
        </footer>
    )
}

export default Footer
